module.exports = __webpack_public_path__ + "static/media/apartment2.84160b85.jpg";